/* eslint-disable no-console */
import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Spinner from '../components/Spinner'
import { colors } from '../../search-common/settings'

const OverLay = styled.div`
  background-color: rgba(0,0,0,0.6);
  width: calc(100% - 40px);
  height: 100%;
  position: absolute;
  z-index: 1000;
  pointer-events: none;
  cursor: progress;
  margin: 20px;
`

const SpinnerContainer = styled.div`
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translate(-50%, -50%);
`

/**
 * LoadingOverlay container.
 */
const LoadingOverlay = ({ isFetching }) => {
  return isFetching ? (
    <OverLay>
      <SpinnerContainer>
        <Spinner color={colors.green} size={100} />
      </SpinnerContainer>
    </OverLay>
  ) : null
}

LoadingOverlay.propTypes = {
  isFetching: PropTypes.bool.isRequired
}

export default LoadingOverlay
